import { Component, Input, OnInit, HostBinding } from "@angular/core";

@Component({
  selector: "small-app-circle-icon",
  templateUrl: "./small-circle-icon.component.html",
  styleUrls: ["./small-circle-icon.component.scss"],
})
export class SmallCircleIconComponent implements OnInit {
  @Input() type: string;
  @Input() title: string="";
  @HostBinding("class.active")
  @Input()
  isActive: boolean;
  @Input()
  count: number = 0;
  constructor() {
    // console.log("title",this.title)
  }

  ngOnInit() {}
}
